/* eslint-disable react-hooks/exhaustive-deps */
import {
  Autocomplete,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid2,
  IconButton,
  OutlinedInput,
  Radio,
  RadioGroup,
  Stack,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Tooltip,
} from '@mui/material';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import { FinalFileDefaultValue, ContentResponse, FinalFileFormFields } from '../../../../data/types/content.interface';
import { capitalize, isEmpty, isNull, isNumber, unionBy } from 'lodash';
import {
  CloseIcon,
  UsedIcon,
  UnusedIcon,
  DownIcon,
  UpIcon,
  NotInUseIcon,
  ViewIcon,
  DeleteIcon,
} from '../../../shared/components/AppIcons';
import { TagType } from '../../../../data/types/tags.interface';
import moment from 'moment';
import theme from '../../../../core/theme';
import ConfirmationDialog from '../../../shared/components/ConfirmationDialog';
import PreFinalFileContentDetails from '../partA/preFinalFileContentDetails';
import ContentsService from '../../services/contents.services';
import FileUploader from '../../../shared/components/FileUploader';
import VideoPlayer from '../../../shared/components/VideoPlayer';
import { useAuthentication } from '../../../auth/services/auth.provider';
import { Relevance } from '../../../topic-tag-scoring/models/topic-tag-scoring';
import { listCuratedInclusions, listRelevances } from '../../../topic-tag-scoring/services/topic-tag-scoring.service';

const useStyles = makeStyles({
  paper: {
    minWidth: '927px',
    height: 'auto',
    borderRadius: '21px',
    boxShadow: 'rgba(242, 242, 242, 1)',
    '& .MuiInputBase-input, .MuiOutlinedInput-input': {
      font: 'Lato !important',
    },
  },
  header: {
    fontSize: '24px',
    verticalAlign: 'text-top',
  },
  close: {
    fontSize: '50px !important',
    color: '#5F6774 !important',
    '& path': {
      fill: `#2C2C2C !important`,
    },
  },
  progressBar: {
    '& .MuiSvgIcon-root': {
      color: '#4db193 !important',
    },
    '& .MuiStepLabel-label': {
      fontFamily: 'Lato !important',
    },
  },
  inputField: {
    margin: '11px 0px 11px 18px',
    '& .MuiStack-root': {
      width: '202px',
      border: '1px solid #E1E3E8',
      borderRadius: '4px',
    },
  },
  tagScores: {
    '& .MuiStack-root': {
      border: '1px solid #E1E3E8',
      borderRadius: '4px',
    },
  },
  field: {
    '& .MuiAutocomplete-inputRoot': {
      minHeight: '40px !important',
      paddingRight: '0 !important',
    },
    '& .MuiInputBase-input': {
      padding: '6px 0',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled, .Mui-error):before': {
      borderBottom: 'none',
    },
  },
  smallText: {
    fontSize: '12px',
    color: theme.palette.outlineInactive.main,
  },
  error: {
    color: '#F57570',
  },
  delete: {
    '& path': {
      fill: `#F67570 !important`,
    },
  },
  editDetails: {
    width: '135px',
    height: '38px',
    backgroundColor: '#F67570 !important',
    fontSize: '18px !important',
    color: '#fff !important',
    boxShadow: 'none !important',
    '& g path': {
      fill: '#ffffff !important',
    },
    '& .error': {
      border: '1px solid red',
    },
  },
  cancel: {
    color: '#F67570 !important',
    marginRight: '24px !important',
    fontSize: '16px !important',
    fontFamily: 'Lato !important',
  },
  linkOverFlow: { width: '49%', textOverflow: 'ellipsis', overflow: 'hidden' },
  downIcon: {
    '& path': {
      fill: '#000 !important',
    },
  },
  link: { width: '95%', wordBreak: 'break-all' },
  input: {
    '& input': {
      minHeight: '40px !important',
      border: '1px solid #E1E3E8',
      borderRadius: '4px',
    },
  },
  path: {
    border: '1px solid #DE5852',
    wordBreak: 'break-all',
    borderRadius: '4px',
    width: '100%',
    height: '40px',
    alignItems: 'center',
  },
  wrapText: {
    '& input': {
      wordBreak: 'break-word',
    },
  },
  radioBtn: {
    '& span': {
      '& svg': {
        fill: '#E1E3E8 !important',
      },
    },
    '& .Mui-checked': {
      '& svg': {
        fill: '#30343F !important',
      },
    },
  },
  outlineInputField: {
    '& .MuiOutlinedInput-root': {
      minHeight: 40,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E1E3E8 !important',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E1E3E8 !important',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E1E3E8 !important',
      borderWidth: '1px !important',
    },
    '& .MuiOutlinedInput-input': {
      outline: 'none !important',
      textOverflow: 'ellipsis',
    },
  },
  textArea: {
    '& .MuiInputBase-root-MuiOutlinedInput-root': {
      height: '-webkit-fill-available !important',
      padding: '10px 14px !important',
    }
  },
  overflow: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  file: {
    '& .MuiStack-root': {
      border: '1px solid #E1E3E8',
      borderRadius: '4px',
    },
    '& input': {
      height: '40px',
      fontFamily: 'Lato',
      padding: '0 !important',
      paddingLeft: '14px !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled, .Mui-error):before': {
      borderBottom: 'none',
    },
  },
  dropdownIcon: {
    fontSize: '42px !important',
    '& path': {
      fill: '#5F6774 !important',
    },
  },
});

interface Props {
  setOpenDetailsModal: Dispatch<SetStateAction<boolean>>;
  id: number | null;
  setRefresh?: Dispatch<SetStateAction<boolean>>;
  setToasterMessage?: Dispatch<SetStateAction<string>>;
  disableEdit?: boolean;
  themeList: TagType[];
}

const steps = [
  'PreFinal File PartA',
  'Upload Final File and Title',
  'Upload Prod File',
  'For Short, Define timeStamp',
  'For Long, add text, Intro/Outro',
  'To Content Marketing',
];

const FinalFileContentDetails: React.FC<Props> = ({ setOpenDetailsModal, id, setRefresh, setToasterMessage, disableEdit, themeList }) => {
  const classes = useStyles();
  const { currentUser: user } = useAuthentication();
  const isAdmin = user?.role.name === 'admin';
  const isCreativeEditor = user?.role.name === 'creative_editor';
  const isContentSpecialist = user?.role.name === 'content_specialist';
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    getValues,
  } = useForm<FinalFileFormFields>({
    defaultValues: FinalFileDefaultValue,
    mode: 'all',
  });
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [cont, setCont] = useState<ContentResponse | null>();
  const [selectedTopics, setSelectedTopics] = useState<TagType[]>([]);
  const [selectedSubTopics, setSelectedSubTopics] = useState<TagType[]>([]);
  const [selectedBrands, setSelectedBrands] = useState<TagType[]>([]);
  const [selectedPersons, setSelectedPersons] = useState<TagType[]>([]);
  const [selectedIdentities, setSelectedIdentities] = useState<TagType[]>([]);
  const [selectedEvents, setSelectedEvents] = useState<TagType[]>([]);
  const [selectedLocations, setSelectedLocations] = useState<TagType[]>([]);
  const [selectedAuthors, setSelectedAuthors] = useState<TagType[]>([]);
  const [ciScores, setCIScores] = useState<Relevance[]>([]);
  const [relevanceScores, setRelevanceScores] = useState<Relevance[]>([]);
  const [selectedCIScore, setSelectedCIScore] = useState<Relevance | null>(null);
  const [selectedRelevanceScore, setSelectedRelevanceScore] = useState<Relevance | null>(null);
  const [isDirtyFileName, setIsDirtyFileName] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false);
  const [prodFile, setProdFile] = useState<string>('');
  const [prodLink, setProdLink] = useState<string>('');
  const [parentProdFile, setParentProdFile] = useState<string>('');
  const [parentProdFileLink, setParentProdFileLink] = useState<string>('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [rawAsset, setRawAsset] = useState<string>('');
  const [preFinalFiles, setPreFinalFiles] = useState<ContentResponse[]>([]);
  const [selectedPreFinalFile, setSelectedPreFinalFile] = useState<ContentResponse | null>(null);
  const [openPreFinalDetailsModal, setOpenPreFinalDetailsModal] = useState(false);
  const [subTitleFile, setSubTitleFile] = useState<string>('');
  const [voiceOverFile, setVoiceOverFile] = useState<string>('');
  const [scriptFile, setScriptFile] = useState<string>('');
  const [cCFile, setCCFile] = useState<string>('');
  const [usedOrUnused, setUsedOrUnused] = useState<string>(cont?.edited ?? '');
  const [contentAccessLink, setContentAccessLink] = useState('');
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [videoType, setVideoType] = useState('short');
  const [file, setFile] = useState<string>('');
  const [mfFile, setMfFile] = useState<string>('');
  const [approved, setApproved] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState<TagType | null>(null);

  const theme = cont?.theme || cont?.themes?.find((t: TagType) => t.type === 'theme')?.name;

  const defaultThemeProps = {
    options: themeList,
    getOptionLabel: (option: TagType) => option.name,
  };

  const getAllFiles = async (type: string) => {
    const result = await ContentsService.getFileList(type);
    if (result) {
      setPreFinalFiles(result);
    }
  };

  useEffect(() => {
    getAllFiles('pre_final');
  }, []);

  const fetchRealContent = async (url: string) => {
    let contentUrl = '';
    if (url) {
      if (url.includes('localhost')) {
        const accessContent = await ContentsService.fetchRealS3Content(url);
        setContentAccessLink(accessContent.url);
      } else {
        contentUrl = await ContentsService.fetchRealDropboxContent(url);
        setContentAccessLink(contentUrl);
      }
    }
  };

  const getAccessLink = (url: string) => {
    const dropboxPath = url.split('/V2 Solutions Team')[1];
    return `https://www.dropbox.com/home/V2%20Solutions%20Team%2F${dropboxPath}`;
  };

  useEffect(() => {
    if (cont?.videoUrl) {
      fetchRealContent(cont?.videoUrl);
    }
    setApproved(cont?.fileType === 'final');
  }, [cont]);

  const getRelevanceAndCuratedInclusion = async () => {
    const result = await listRelevances();
    if (result) {
      setRelevanceScores(result);
    }

    const ciResult = await listCuratedInclusions();
    if (ciResult) {
      setCIScores(ciResult);
    }
  };

  useEffect(() => {
    getRelevanceAndCuratedInclusion();
  }, []);

  useEffect(() => {
    if (preFinalFiles.length > 0 && cont?.fileType !== 'final') {
      const preFinalFile = preFinalFiles?.find((file) => file.id === cont?.preFinalFileId);
      setSelectedPreFinalFile(preFinalFile || null);
      setRawAsset(preFinalFile?.rawAsset ?? '');
    }
  }, [preFinalFiles, cont]);

  useEffect(() => {
    setValue('productionFile', selectedPreFinalFile?.productionFile ?? '');
    setValue('productionLink', selectedPreFinalFile?.productionLink ?? '');
    setValue('rawAsset', selectedPreFinalFile?.rawAsset ?? '');
    setRawAsset(selectedPreFinalFile?.rawAsset ?? '');
    setProdFile(selectedPreFinalFile?.productionFile ?? '');
    setProdLink(selectedPreFinalFile?.productionLink ?? '');
    setSelectedBrands(selectedPreFinalFile?.brands || []);
    setSelectedTopics(
      unionBy(selectedTopics, selectedPreFinalFile?.themes?.filter((theme) => theme.type === 'topic') || [], 'name')
    );
    setSelectedSubTopics(
      unionBy(
        selectedSubTopics,
        selectedPreFinalFile?.themes?.filter((theme) => theme.type === 'sub-topic') || [],
        'name'
      )
    );
    setSelectedPersons(selectedPreFinalFile?.personalities || []);
    setSelectedIdentities(selectedPreFinalFile?.identity_tags || []);
    setSelectedLocations(selectedPreFinalFile?.location_tags || []);
    setSelectedAuthors(selectedPreFinalFile?.authors || []);
    setSelectedEvents(selectedPreFinalFile?.event_tags || []);
    setVideoType(videoType ? videoType : selectedPreFinalFile?.videoType || 'short');
  }, [selectedPreFinalFile]);

  useEffect(() => {
    if (ciScores.length > 0) {
      setSelectedCIScore(ciScores?.find((ci) => ci.id === cont?.curatedInclusionTypeId) || null);
    }
  }, [ciScores, cont]);

  useEffect(() => {
    if (relevanceScores.length > 0) {
      setSelectedRelevanceScore(relevanceScores?.find((r) => r.id === cont?.relevanceTypeId) || null);
    }
  }, [relevanceScores, cont]);

  const getPreFinalFileDetails = async (preFinalFileId: number) => {
    const preFinalFile = await ContentsService.getDetails(preFinalFileId);
    if (preFinalFile) {
      setSelectedPreFinalFile(preFinalFile);
    }
  };

  const getContentDetails = async (id: number) => {
    const content = await ContentsService.getDetails(id);
    if (content) {
      if (isNumber(content.preFinalFileId)) {
        await getPreFinalFileDetails(content.preFinalFileId);
      }

      setCont(content);
      setValue('title', content.title);
      setValue('fileName', content.filename);
      setRawAsset(content.rawAsset);
      setValue('productionFile', content.productionFile);
      setValue('productionLink', content.productionLink);
      setValue('parentProdFile', content.parentProdFile ?? '');
      setValue('parentProdFileLink', content.parentProdFileLink ?? '');
      setValue('startTime', content.startTime ?? '');
      setValue('endTime', content.endTime ?? '');
      setValue('text', content.text);
      setProdFile(content.productionFile);
      setProdLink(content.productionLink);
      setParentProdFile(content.parentProdFile ?? '');
      setParentProdFileLink(content.parentProdFileLink ?? '');
      setSelectedBrands(content.brands || []);
      setSelectedTopics(content.themes?.filter((theme) => theme.type === 'topic') || []);
      setSelectedSubTopics(content.themes?.filter((theme) => theme.type === 'sub-topic') || []);
      setStartTime(content.startTime ?? '');
      setEndTime(content.endTime ?? '');
      setSelectedPersons(content.personalities || []);
      setSelectedIdentities(content.identity_tags || []);
      setSelectedLocations(content.location_tags || []);
      setSelectedAuthors(content.authors || []);
      setSelectedEvents(content.event_tags || []);
      setUsedOrUnused(content.edited);
      setVideoType(content.videoType);
      setFile(content?.thumbnail ?? '');
      setSubTitleFile(content.subTitleFile ?? '');
      setVoiceOverFile(content.voiceOverFile ?? '');
      setScriptFile(content.scriptFile ?? '');
      setCCFile(content.cCFile ?? '');
      setMfFile(content?.musicFileLicense ?? '');
    }
  };

  useEffect(() => {
    if (id) {
      getContentDetails(id);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, []);

  const isDisabled = () => {
    return isNull(selectedPreFinalFile) || isEmpty(rawAsset) || isEmpty(prodFile) || isEmpty(prodLink);
  };

  const handleConfirm = async (form?: FinalFileFormFields) => {
    try {
      const { title, fileName } = getValues();

      const formData = new FormData();
      if (cont?.assetContentType && cont.assetContentType.name === 'video') {
        if (subTitleFile) {
          formData.append('subTitleFile', subTitleFile || (form?.subTitleFile as File));
        }
        if (voiceOverFile) {
          formData.append('voiceOverFile', voiceOverFile || (form?.voiceOverFile as File));
        }
        if (scriptFile) {
          formData.append('scriptFile', scriptFile || (form?.scriptFile as File));
        }
        if (cCFile) {
          formData.append('cCFile', cCFile || (form?.cCFile as File));
        }
        if (file) {
          const files = file || (form?.file as File);
          formData.append('thumbnail', files);
        }
        if (mfFile) {
          const mp3Files = mfFile || (form?.mfFile as File);
          formData.append('musicFileLicense', mp3Files);
        }
      }
      formData.append('title', title);
      formData.append('filename', fileName);
      formData.append('brands', JSON.stringify(selectedBrands));
      formData.append('topics', JSON.stringify(selectedTopics));
      formData.append('subTopics', JSON.stringify(selectedSubTopics));
      formData.append('persons', JSON.stringify(selectedPersons));
      formData.append('identities', JSON.stringify(selectedIdentities));
      formData.append('locations', JSON.stringify(selectedLocations));
      formData.append('events', JSON.stringify(selectedEvents));
      formData.append('authors', JSON.stringify(selectedAuthors));
      formData.append('startTime', startTime);
      formData.append('endTime', endTime);
      formData.append(
        'preFinalFileId',
        isNumber(selectedPreFinalFile?.id) ? JSON.stringify(selectedPreFinalFile?.id ?? '') : 'null'
      );
      formData.append('rawAsset', rawAsset);
      formData.append('productionFile', prodFile);
      formData.append('productionLink', prodLink);
      formData.append('parentProdFile', parentProdFile);
      formData.append('parentProdFileLink', parentProdFileLink);
      formData.append('curatedInclusion', JSON.stringify(selectedCIScore));
      formData.append('relevance', JSON.stringify(selectedRelevanceScore));
      formData.append('fileType', approved ? 'final' : cont?.fileType || 'pre_final');
      formData.append('videoType', videoType || 'short');
      formData.append('usedOrUnused', usedOrUnused);

      const contentTheme = cont?.themes?.filter((t) => t.type === 'theme') || [];

      if (selectedTheme && contentTheme.length === 0) {
        formData.append('themes', JSON.stringify(selectedTheme));
      } else {
        formData.append('themes', JSON.stringify(cont?.themes?.filter((t) => t.type === 'theme') || []));
      }

      if (id && ((!isDisabled() && isAdmin) || isContentSpecialist || isCreativeEditor)) {
        const content = await ContentsService.updateContentDetails(id, 'final', undefined, formData, {});
        if (content) {
          setToasterMessage && setToasterMessage('Changes Saved Successfully');
        }
        if (setRefresh) {
          setRefresh(true);
        }
        setOpenDetailsModal(false);
      }
    } catch (error) {
      setErrorMessage(error?.response?.data[0]?.message || 'Please try again');
    }
  };

  const onSubmit: SubmitHandler<FinalFileFormFields> = async (form) => {
    setIsFormSubmitted(true);
    if (isDirtyFileName) {
      setShowConfirmationModal(true);
    } else {
      await handleConfirm(form);
    }
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue('title', e.target.value);
    if (
      e.target.value.endsWith('_Title_Final') ||
      e.target.value.endsWith('_Title_Long_Final') ||
      e.target.value.endsWith('_Title_Short_Final')
    ) {
      setErrorMessage('');
    } else {
      setErrorMessage('Please enter title as per the naming convention');
    }
  };

  const handleFileName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsDirtyFileName(true);
    setValue('fileName', e.target.value);
    if (e.target.value.endsWith('Final')) {
      setErrorMessage('');
    } else {
      setErrorMessage('Please enter file name as per the naming convention');
    }
  };

  const handleThemeChange = (e: React.SyntheticEvent<Element, Event>, values: TagType | null) => {
    setSelectedTheme(values);
  };

  const handleCIScoreChange = (e: React.SyntheticEvent<Element, Event>, value: Relevance | null) => {
    if (!isNull(value)) {
      setSelectedCIScore(value);
    }
  };

  const handleRelevanceScoreChange = (e: React.SyntheticEvent<Element, Event>, value: Relevance | null) => {
    if (!isNull(value)) {
      setSelectedRelevanceScore(value);
    }
  };

  const handlePreFinalFileChange = (e: React.SyntheticEvent<Element, Event>, value: ContentResponse | null) => {
    if (!isNull(value)) {
      setSelectedPreFinalFile(value);
    }
  };

  const handleParentProdFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isEmpty(e.target.value)) {
      setErrorMessage('Please add parent production file');
    } else {
      setParentProdFile(e.target.value);
      setErrorMessage('');
    }
  };

  const handleParentProdLinkChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (isEmpty(e.target.value)) {
      setErrorMessage('Please add parent production file link');
    } else {
      setParentProdFileLink(e.target.value);
      setErrorMessage('');
    }
  };

  const handleUsedOrUnused = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsedOrUnused(e.target.value);
  };

  const handleVideoTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVideoType((event.target as HTMLInputElement).value);
  };

  return (
    <>
      <Dialog
        open
        aria-modal="true"
        role="dialog"
        onClose={() => setOpenDetailsModal(false)}
        PaperProps={{
          onClick: (e: any) => e.stopPropagation(),
          className: classes.paper,
        }}
      >
        <DialogTitle>
          <Grid2 container justifyContent="space-between">
            <Grid2>
              <span className={classes.header}>{`Content Creation Final File Details`}</span>
            </Grid2>
            <Grid2 container justifyContent="flex-end">
              <IconButton onClick={() => setOpenDetailsModal(false)} role="button" sx={{ padding: 0 }}>
                <CloseIcon viewBox="0 0 42 42" className={classes.close} />
              </IconButton>
            </Grid2>
          </Grid2>
          <Grid2>
            <Divider
              orientation="horizontal"
              flexItem
              sx={{
                backgroundColor: '#E1E3E8',
                paddingBottom: '1px',
              }}
            />
          </Grid2>
        </DialogTitle>

        <DialogContent sx={{ paddingBottom: '0px' }}>
          {errorMessage && errorMessage.length > 0 && (
            <Grid2 container justifyContent="center">
              <div className="text-danger mb-1 pb-5 text-center">{errorMessage}</div>
            </Grid2>
          )}
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container direction="column" className={classes.progressBar}>
              <Stepper activeStep={5} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Grid2>

            <Grid2 container direction="column" flexWrap="nowrap">
              <Grid2 container mt={4}>
                <Grid2 container>
                  <span className={classes.smallText}>
                    <VideoPlayer videoUrl={contentAccessLink ?? ''} thumbnail={cont?.thumbnail} />
                  </span>
                </Grid2>

                <Grid2 style={{ cursor: 'pointer' }} container direction="column" ml={3} width="23%">
                  <Grid2>
                    <span>Usage</span>
                  </Grid2>
                  <Grid2 container width="100%" justifyContent="space-between">
                    <Grid2 width="80%">
                      {usedOrUnused === 'Unused' ? (
                        <span>
                          <UnusedIcon viewBox="5 6 32 32" sx={{ fontSize: '42px' }} />
                          Not Used
                        </span>
                      ) : usedOrUnused === 'NotInUse' ? (
                        <span>
                          <NotInUseIcon viewBox="5 6 32 32" sx={{ fontSize: '42px' }} />
                          Not In Use
                        </span>
                      ) : (
                        <span>
                          <UsedIcon viewBox="5 6 32 32" style={{ fontSize: '42px' }} />
                          Used
                        </span>
                      )}
                    </Grid2>
                    <Grid2 width="20%">
                      <Button onClick={() => setAnchorEl(!anchorEl)}>
                        {anchorEl ? (
                          <UpIcon style={{ fontSize: '35px' }} className={classes.downIcon} />
                        ) : (
                          <DownIcon style={{ fontSize: '35px' }} className={classes.downIcon} />
                        )}
                      </Button>
                    </Grid2>
                  </Grid2>
                  {anchorEl && (
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={usedOrUnused}
                        onChange={handleUsedOrUnused}
                      >
                        <Grid2 container direction="column">
                          <FormControlLabel
                            sx={{ ml: '4px' }}
                            className={classes.radioBtn}
                            value="Used"
                            control={<Radio />}
                            label="Used"
                          />
                          <FormControlLabel
                            sx={{ ml: '4px' }}
                            className={classes.radioBtn}
                            value="Unused"
                            control={<Radio />}
                            label="Not Used"
                          />
                          <FormControlLabel
                            sx={{ ml: '4px' }}
                            value="NotInUse"
                            control={<Radio />}
                            label="Not In Use"
                          />
                        </Grid2>
                      </RadioGroup>
                    </FormControl>
                  )}
                </Grid2>
              </Grid2>

              <Grid2 container direction="column">
                <span className={classes.smallText} style={{ color: 'black' }}>
                  Date Added: {moment(cont?.createdAt).format('YYYY-MM-DD')}
                </span>
                <span className={classes.smallText} style={{ color: 'black' }}>
                  Last Updated on Dropbox: {moment(cont?.lastUpdatedAt).format('YYYY-MM-DD')}
                </span>
              </Grid2>

              <Grid2 container mt={2} direction="column" width="100%">
                <Grid2>
                  <label>Final File*</label>
                </Grid2>
                <Grid2>
                  <input
                    {...register('fileName', { required: true })}
                    name="fileName"
                    id="fileName"
                    style={{ paddingLeft: '14px', borderRadius: '4px' }}
                    className={`form-control ${errors.fileName && 'is-invalid'}`}
                    onChange={(e) => handleFileName(e)}
                  />
                </Grid2>
                {isEmpty(getValues('fileName')) && (
                  <span className={`${classes.smallText} ${classes.error}`}>Filename can not be empty</span>
                )}
              </Grid2>

              <Grid2 container mt={2} direction="column" width="100%">
                <Grid2>
                  <label>Title*</label>
                </Grid2>
                <Grid2>
                  <input
                    {...register('title', { required: true })}
                    name="title"
                    id="title"
                    style={{ paddingLeft: '14px', borderRadius: '4px' }}
                    className={`form-control ${errors.title && 'is-invalid'}`}
                    onChange={(e) => handleTitleChange(e)}
                  />
                </Grid2>
                {isEmpty(getValues('title')) && (
                  <span className={`${classes.smallText} ${classes.error}`}>Title can't be empty</span>
                )}
              </Grid2>

              <Grid2 container>
                <Grid2 container direction="column" sx={{ width: '48%' }}>
                  {cont?.assetContentType && (
                    <Grid2 container direction="column" mt={1.5}>
                      <label>Content Type</label>
                      <FormControl>
                        <OutlinedInput
                          className={classes.outlineInputField}
                          placeholder="contentType"
                          value={cont?.assetContentType?.name ? capitalize(cont?.assetContentType?.name) : ''}
                        />
                      </FormControl>
                    </Grid2>
                  )}
                </Grid2>
                {cont?.assetContentType?.name === 'video' && (
                  <Grid2 container direction="column" mt={1.5} ml={2} sx={{ width: '48%' }}>
                    <>
                      <label>Video Type*</label>
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={videoType || cont?.videoType}
                          onChange={handleVideoTypeChange}
                        >
                          <Grid2 container>
                            <FormControlLabel
                              value="long_original"
                              control={<Radio />}
                              className={classes.radioBtn}
                              label={
                                <Tooltip title="Original video clip">
                                  <span>Long Original</span>
                                </Tooltip>
                              }
                            />
                            <FormControlLabel
                              value="long_chopped"
                              control={<Radio />}
                              className={classes.radioBtn}
                              label={
                                <Tooltip title="Short videos made out of original clip">
                                  <span>Long Chopped</span>
                                </Tooltip>
                              }
                            />
                            <FormControlLabel
                              value="short"
                              control={<Radio />}
                              className={classes.radioBtn}
                              label={
                                <Tooltip title="Original short video clip">
                                  <span>Short</span>
                                </Tooltip>
                              }
                            />
                          </Grid2>
                        </RadioGroup>
                      </FormControl>
                    </>
                  </Grid2>
                )}
              </Grid2>

              <Grid2 container direction="column" width="100%" mt={2}>
                <label>Theme</label>
                {theme ? (
                  <FormControl>
                    <OutlinedInput
                      className={classes.outlineInputField}
                      placeholder="Theme"
                      value={theme}
                    />
                  </FormControl>
                ) : (
                  <Stack spacing={1} sx={{ width: 300 }}>
                    <Autocomplete
                      {...defaultThemeProps}
                      id="auto-highlight"
                      autoHighlight
                      value={selectedTheme}
                      onChange={handleThemeChange}
                      className={`form-control ${errors.theme && 'is-invalid'}`}
                      renderInput={(params) => <TextField {...params} label="" variant="standard" />}
                    />
                  </Stack>)
                }
              </Grid2>

              <Grid2 container mt={2} width="101%">
                <Grid2 container direction="column" sx={{ width: '49%' }}>
                  <label>Category</label>
                  <FormControl>
                    <OutlinedInput
                      className={classes.outlineInputField}
                      placeholder="category"
                      value={cont?.category ?? ''}
                    />
                  </FormControl>
                </Grid2>
                <Grid2 container direction="column" ml="9px" sx={{ width: '49%' }}>
                  <label>Sub Category</label>
                  <FormControl>
                    <OutlinedInput
                      className={classes.outlineInputField}
                      placeholder="sub category"
                      value={cont?.subCategory ?? ''}
                    />
                  </FormControl>
                </Grid2>
              </Grid2>

              <Grid2 container direction="column" mt={2} width="100%">
                <label>Main Folder</label>
                <FormControl>
                  <OutlinedInput
                    className={classes.outlineInputField}
                    placeholder="main folder"
                    value={cont?.mainFolder ?? ''}
                  />
                </FormControl>
              </Grid2>

              <Grid2 container direction="column" mt={2} width="100%">
                <label>Sub Folder</label>
                <FormControl>
                  <OutlinedInput
                    className={classes.outlineInputField}
                    placeholder="sub folder"
                    value={cont?.subFolder ?? ''}
                  />
                </FormControl>
              </Grid2>

              {cont?.fileType !== 'final' && <Grid2 container mt={2} direction="column" width="100%">
                <Grid2>
                  <label>Pre Final Files*</label>
                </Grid2>
                <Grid2 container width="100%">
                  <Grid2 width="95%" className={classes.file}>
                    <Stack spacing={1}>
                      <Autocomplete
                        options={preFinalFiles || []}
                        getOptionLabel={(option) => option.filename}
                        id="auto-highlight"
                        value={selectedPreFinalFile}
                        autoHighlight
                        onChange={handlePreFinalFileChange}
                        onOpen={() => setOpen(true)}
                        onClose={() => setOpen(false)}
                        readOnly={isContentSpecialist}
                        popupIcon={
                          open ? (
                            <UpIcon className={classes.dropdownIcon} />
                          ) : (
                            <DownIcon className={classes.dropdownIcon} />
                          )
                        }
                        renderInput={(params) => <TextField {...params} variant="standard" />}
                      />
                    </Stack>
                  </Grid2>
                  <Grid2 container justifyContent="flex-end" width="5%">
                    <IconButton onClick={() => setOpenPreFinalDetailsModal(true)} role="button" sx={{ padding: 0 }}>
                      <ViewIcon viewBox="0 0 42 42" />
                    </IconButton>
                  </Grid2>
                </Grid2>
                {isNull(selectedPreFinalFile) && isFormSubmitted && isAdmin && (
                  <span className={`${classes.smallText} ${classes.error}`}>Pre Final File name can not be empty</span>
                )}
              </Grid2>}

              <Grid2 container mt={2} direction="column" width="100%">
                <Grid2>
                  <label>Parent Raw Asset Link*</label>
                </Grid2>
                <Grid2 container width="100%">
                  <Grid2 width="95%" className={classes.file}>
                    <FormControl fullWidth>
                      <OutlinedInput className={classes.outlineInputField} placeholder="Raw Asset" value={cont?.fileType === 'final' ? cont?.rawAsset : rawAsset} />
                    </FormControl>
                  </Grid2>
                  <Grid2 container justifyContent="flex-end" width="5%">
                    <a href={rawAsset} target="_blank" rel="noreferrer" aria-disabled={isEmpty(rawAsset)}>
                      <ViewIcon viewBox="0 0 42 42" />
                    </a>
                  </Grid2>
                </Grid2>
                {isEmpty(rawAsset) && isFormSubmitted && isAdmin && (
                  <span className={`${classes.smallText} ${classes.error}`}>Raw Asset can not be empty</span>
                )}
              </Grid2>

              <Grid2 container mt={2} direction="column" width="100%">
                <Grid2>
                  <label>Parent prod File Name</label>
                </Grid2>
                <Grid2 className={classes.input}>
                  <input
                    {...register('parentProdFile', { required: false })}
                    name="parentProdFile"
                    id="parentProdFile"
                    value={parentProdFile === 'null' ? '' : parentProdFile ?? ''}
                    style={{ paddingLeft: '14px' }}
                    className="form-control"
                    onChange={(e) => handleParentProdFileChange(e)}
                    readOnly={isContentSpecialist}
                  />
                </Grid2>
              </Grid2>

              <Grid2 container direction="column" width="100%" mt={2}>
                <Grid2>
                  <label>Parent Prod File Link</label>
                </Grid2>
                <Grid2 container width="100%">
                  <Grid2 width="95%" className={classes.file}>
                    <FormControl fullWidth>
                      <OutlinedInput
                        className={classes.outlineInputField}
                        placeholder="Parent Production Link"
                        value={parentProdFileLink}
                        onChange={(e) => handleParentProdLinkChange(e)}
                        readOnly={isContentSpecialist}
                      />
                    </FormControl>
                  </Grid2>
                  <Grid2 container justifyContent="flex-end" width="5%">
                    <a
                      href={parentProdFileLink}
                      target="_blank"
                      rel="noreferrer"
                      aria-disabled={isEmpty(parentProdFileLink)}
                    >
                      <ViewIcon viewBox="0 0 42 42" />
                    </a>
                  </Grid2>
                </Grid2>
              </Grid2>

              <Grid2 container direction="column" width="100%" mt={2}>
                <Grid2>
                  <label>Production File Name*</label>
                </Grid2>
                <Grid2 container width="100%">
                  <Grid2 width="95%" className={classes.file}>
                    <FormControl fullWidth>
                      <OutlinedInput
                        className={classes.outlineInputField}
                        placeholder="Production File"
                        value={prodFile}
                        readOnly={isContentSpecialist}
                      />
                    </FormControl>
                  </Grid2>
                </Grid2>
                {isEmpty(prodFile) && isFormSubmitted && isAdmin && (
                  <span className={`${classes.smallText} ${classes.error}`}>Production File name can not be empty</span>
                )}
              </Grid2>

              <Grid2 container direction="column" width="100%" mt={2}>
                <Grid2>
                  <label>Production File Link*</label>
                </Grid2>
                <Grid2 container width="100%">
                  <Grid2 width="95%" className={classes.file}>
                    <FormControl fullWidth>
                      <OutlinedInput
                        className={classes.outlineInputField}
                        placeholder="Production Link"
                        value={prodLink}
                        readOnly={isContentSpecialist}
                      />
                    </FormControl>
                  </Grid2>
                  <Grid2 container justifyContent="flex-end" width="5%">
                    <a href={prodLink} target="_blank" rel="noreferrer" aria-disabled={isEmpty(prodLink)}>
                      <ViewIcon viewBox="0 0 42 42" />
                    </a>
                  </Grid2>
                </Grid2>
                {isEmpty(prodLink) && isFormSubmitted && isAdmin && (
                  <span className={`${classes.smallText} ${classes.error}`}>Production File name can not be empty</span>
                )}
              </Grid2>

              <Grid2 container>
                <Grid2 container direction="column" className={classes.inputField} style={{ margin: '11px 0 11px 0' }}>
                  <label>Topic*</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={[]}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      multiple
                      autoHighlight
                      value={selectedTopics}
                      readOnly
                      popupIcon={<DownIcon aria-disabled className={classes.dropdownIcon} />}
                      className={`${classes.field} ${errors.topic && 'is-invalid'}`}
                      renderInput={(params) => <TextField {...params} variant="standard" />}
                    />
                  </Stack>
                  {selectedTopics.length === 0 && isFormSubmitted && isAdmin && (
                    <span className={`${classes.smallText} ${classes.error}`}>Topic can not be empty</span>
                  )}
                </Grid2>

                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Sub-Topic*</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={[]}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      value={selectedSubTopics}
                      readOnly
                      popupIcon={<DownIcon aria-disabled className={classes.dropdownIcon} />}
                      className={`${classes.field} ${errors.subTopic && 'is-invalid'}`}
                      renderInput={(params) => <TextField {...params} variant="standard" />}
                    />
                  </Stack>
                  {selectedSubTopics.length === 0 && isFormSubmitted && isAdmin && (
                    <span className={`${classes.smallText} ${classes.error}`}>Sub Topic can not be empty</span>
                  )}
                </Grid2>

                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Brands</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={[]}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      className={classes.field}
                      value={selectedBrands}
                      readOnly
                      popupIcon={<DownIcon aria-disabled className={classes.dropdownIcon} />}
                      renderInput={(params) => <TextField {...params} variant="standard" />}
                    />
                  </Stack>
                </Grid2>

                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Persons</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={[]}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      className={classes.field}
                      value={selectedPersons}
                      readOnly
                      popupIcon={<DownIcon aria-disabled className={classes.dropdownIcon} />}
                      renderInput={(params) => <TextField {...params} variant="standard" />}
                    />
                  </Stack>
                </Grid2>
              </Grid2>

              <Grid2 container>
                <Grid2 container direction="column" className={classes.inputField} style={{ margin: '11px 0 11px 0' }}>
                  <label>Identity</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={[]}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      className={classes.field}
                      value={selectedIdentities}
                      readOnly
                      popupIcon={<DownIcon aria-disabled className={classes.dropdownIcon} />}
                      renderInput={(params) => <TextField {...params} variant="standard" />}
                    />
                  </Stack>
                </Grid2>
                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Location</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={[]}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      className={classes.field}
                      readOnly
                      popupIcon={<DownIcon aria-disabled className={classes.dropdownIcon} />}
                      value={selectedLocations}
                      renderInput={(params) => <TextField {...params} variant="standard" />}
                    />
                  </Stack>
                </Grid2>
                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Events</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={[]}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      multiple
                      value={selectedEvents}
                      autoHighlight
                      className={classes.field}
                      readOnly
                      popupIcon={<DownIcon aria-disabled className={classes.dropdownIcon} />}
                      renderInput={(params) => <TextField {...params} variant="standard" />}
                    />
                  </Stack>
                </Grid2>
                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Author</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={[]}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      className={classes.field}
                      value={selectedAuthors}
                      readOnly
                      popupIcon={<DownIcon aria-disabled className={classes.dropdownIcon} />}
                      renderInput={(params) => <TextField {...params} variant="standard" />}
                    />
                  </Stack>
                </Grid2>
              </Grid2>

              <Grid2 container mt={2} width="101%">
                <Grid2 container width="49%" flexWrap="nowrap">
                  <Grid2 container direction="column" ml={0} className={classes.input}>
                    <label>Clip Start Time</label>
                    <FormControl>
                      <input
                        {...register('startTime', { required: false })}
                        name="startTime"
                        id="startTime"
                        style={{ width: '205px', paddingLeft: '14px' }}
                        className="form-control"
                        onChange={(e) => setStartTime(e.target.value)}
                      />
                    </FormControl>
                  </Grid2>
                  <Grid2 container direction="column" ml={1} className={classes.input}>
                    <label>Clip End Time</label>
                    <input
                      {...register('endTime', { required: false })}
                      name="endTime"
                      id="endTime"
                      style={{ width: '205px', paddingLeft: '14px' }}
                      className="form-control"
                      onChange={(e) => setEndTime(e.target.value)}
                    />
                  </Grid2>
                </Grid2>
              </Grid2>

              <Grid2 container flexWrap="nowrap" width="100%" mt={2}>
                <Grid2 container direction="column" width="49%" className={classes.tagScores}>
                  <label>Curated Inclusion score</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={ciScores}
                      getOptionLabel={(option: Relevance) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      value={selectedCIScore}
                      className={classes.field}
                      onChange={handleCIScoreChange}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      popupIcon={
                        open ? (
                          <UpIcon className={classes.dropdownIcon} />
                        ) : (
                          <DownIcon className={classes.dropdownIcon} />
                        )
                      }
                      renderInput={(params) => <TextField {...params} variant="standard" />}
                    />
                  </Stack>
                </Grid2>
                <Grid2 container direction="column" ml={2} width="49%" className={classes.tagScores}>
                  <label>Relevance score</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={relevanceScores}
                      getOptionLabel={(option: Relevance) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      className={classes.field}
                      value={selectedRelevanceScore}
                      onChange={handleRelevanceScoreChange}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      popupIcon={
                        open ? (
                          <UpIcon className={classes.dropdownIcon} />
                        ) : (
                          <DownIcon className={classes.dropdownIcon} />
                        )
                      }
                      renderInput={(params) => <TextField {...params} variant="standard" />}
                    />
                  </Stack>
                </Grid2>
              </Grid2>

              {cont?.assetContentType?.name === 'video' && (
                <Grid2 container mt={2} direction="column">
                  <Grid2 container flexWrap="nowrap">
                    <Grid2 container direction="column" className={classes.linkOverFlow}>
                      <label htmlFor='subtitle' style={{ marginRight: '32px' }}>Sub Title</label>
                      {!isEmpty(subTitleFile) ? (
                        <FormControl fullWidth>
                          <Grid2 container>
                            <OutlinedInput className={classes.outlineInputField} sx={{ width: subTitleFile ? '82%' : '100%', height: "40px" }} value={subTitleFile} />
                            <IconButton onClick={() => setSubTitleFile('')}>
                              <DeleteIcon viewBox="0 12 30 30" fontSize='large' className={classes.delete} />
                            </IconButton>
                          </Grid2>
                        </FormControl>
                      ) : (
                        <FileUploader
                          handleFileUpload={() => null}
                          setErrorMessage={setErrorMessage}
                          applyStyles={false}
                          id="subtitle"
                          isContentUpload={false}
                          setSelectedFile={setSubTitleFile}
                          readOnly={isCreativeEditor}
                        />
                      )}
                    </Grid2>
                    <Grid2 container direction="column" ml={2} className={classes.linkOverFlow}>
                      <label htmlFor='voiceover' style={{ marginRight: '32px' }}>Voice Over</label>
                      {!isEmpty(voiceOverFile) ? (
                        <FormControl fullWidth>
                          <Grid2 container>
                            <OutlinedInput className={classes.outlineInputField} sx={{ width: voiceOverFile ? '82%' : '100%', height: "40px" }} value={voiceOverFile} />
                            <IconButton onClick={() => setVoiceOverFile('')}>
                              <DeleteIcon viewBox="0 12 30 30" fontSize='large' className={classes.delete} />
                            </IconButton>
                          </Grid2>
                        </FormControl>
                      ) : (
                        <FileUploader
                          handleFileUpload={() => null}
                          setErrorMessage={setErrorMessage}
                          applyStyles={false}
                          id="voiceover"
                          isContentUpload={false}
                          setSelectedFile={setVoiceOverFile}
                          readOnly={isCreativeEditor}
                        />
                      )}
                    </Grid2>
                  </Grid2>

                  <Grid2 container flexWrap="nowrap" mt={2}>
                    <Grid2 container direction="column" className={classes.linkOverFlow}>
                      <label htmlFor='script' style={{ marginRight: '32px' }}>Script</label>
                      {!isEmpty(scriptFile) ? (
                        <FormControl fullWidth>
                          <Grid2 container>
                            <OutlinedInput className={classes.outlineInputField} sx={{ width: scriptFile ? '82%' : '100%', height: "40px" }} value={scriptFile} />
                            <IconButton onClick={() => setScriptFile('')}>
                              <DeleteIcon viewBox="0 12 30 30" fontSize='large' className={classes.delete} />
                            </IconButton>
                          </Grid2>
                        </FormControl>
                      ) : (
                        <FileUploader
                          handleFileUpload={() => null}
                          setErrorMessage={setErrorMessage}
                          applyStyles={false}
                          id="script"
                          isContentUpload={false}
                          setSelectedFile={setScriptFile}
                          readOnly={isCreativeEditor}
                        />
                      )}
                    </Grid2>
                    <Grid2 container direction="column" ml={2} className={classes.linkOverFlow}>
                      <label htmlFor='creative_correction' style={{ marginRight: '32px' }}>Creative Correction</label>
                      {!isEmpty(cCFile) ? (
                        <FormControl fullWidth>
                          <Grid2 container>
                            <OutlinedInput className={classes.outlineInputField} sx={{ width: cCFile ? '82%' : '100%', height: "40px" }} value={cCFile} />
                            <IconButton onClick={() => setCCFile('')}>
                              <DeleteIcon viewBox="0 12 30 30" fontSize='large' className={classes.delete} />
                            </IconButton>
                          </Grid2>
                        </FormControl>
                      ) : (
                        <FileUploader
                          handleFileUpload={() => null}
                          setErrorMessage={setErrorMessage}
                          applyStyles={false}
                          id="creative_correction"
                          isContentUpload={false}
                          setSelectedFile={setCCFile}
                          readOnly={isCreativeEditor}
                        />
                      )}
                    </Grid2>
                  </Grid2>
                </Grid2>
              )}

              <Grid2 container direction="column" mt={1}>
                <label>Final File Breadcrumb</label>
                <FormControl fullWidth sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
                  <TextField
                    placeholder="breadcrumb"
                    value={cont?.pathLink}
                    variant="outlined"
                    multiline
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    minRows={2}
                    maxRows={4}
                    sx={{ height: 'auto', wordBreak: 'break-word' }}
                    className={classes.outlineInputField}
                  />
                </FormControl>
              </Grid2>

              <Grid2 container className="mt-6" flexWrap="nowrap">
                <Grid2 container direction="column" className={classes.linkOverFlow}>
                  <label>Thumbnail</label>
                  {!isEmpty(file) ? (
                    <FormControl fullWidth>
                      <Grid2 container>
                        <OutlinedInput className={classes.outlineInputField} sx={{
                          width: file ? '82%' : '100%', height: "40px", overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }} value={file} />
                        <IconButton onClick={() => setFile('')}>
                          <DeleteIcon viewBox="0 12 30 30" fontSize='large' className={classes.delete} />
                        </IconButton>
                      </Grid2>
                    </FormControl>
                  ) : (
                    <FileUploader
                      handleFileUpload={() => null}
                      setErrorMessage={setErrorMessage}
                      applyStyles={false}
                      id="thumbnail"
                      isContentUpload={false}
                      isPublished={cont?.published}
                      setSelectedFile={setFile}
                    />
                  )}
                </Grid2>
                <Grid2 container direction="column" ml={2} className={classes.linkOverFlow} flexWrap="nowrap">
                  <label>Music File License</label>
                  {mfFile ? (
                    <FormControl fullWidth>
                      <Grid2 container>
                        <OutlinedInput className={classes.outlineInputField} sx={{
                          width: mfFile ? '82%' : '100%', height: "40px", overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }} value={mfFile} />
                        <IconButton onClick={() => setMfFile('')}>
                          <DeleteIcon viewBox="0 12 30 30" fontSize='large' className={classes.delete} />
                        </IconButton>
                      </Grid2>
                    </FormControl>
                  ) : (
                    <FileUploader
                      handleFileUpload={() => null}
                      setErrorMessage={setErrorMessage}
                      applyStyles={false}
                      id="mfFile"
                      isContentUpload={false}
                      isPublished={cont?.published}
                      setSelectedFile={setMfFile}
                    />
                  )}
                </Grid2>
              </Grid2>

              <Grid2 container direction="column" mt={2}>
                <label>Final File Path</label>
                <Grid2 container mt={1} className={classes.path} p={0.5}>
                  {cont && (
                    <a
                      href={cont.videoUrl.includes('localhost') ? contentAccessLink : getAccessLink(cont.videoUrl)}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: '#DE5852', textDecoration: 'none' }}
                      className={classes.overflow}
                    >
                      {cont?.videoUrl}
                    </a>
                  )}
                </Grid2>
              </Grid2>

              <Grid2 container justifyContent="flex-Start" mt={2}>
                <Grid2>
                  <Tooltip title="Add Approved for publishing">
                    <span>Approved for Publishing</span>
                  </Tooltip>
                </Grid2>
                <Grid2 ml={1}>
                  <input
                    type="checkbox"
                    checked={approved}
                    style={{ cursor: 'pointer' }}
                    className="checkbox"
                    name="bulk-upload"
                    onChange={() => {
                      setApproved(!approved);
                    }}
                  />
                </Grid2>
              </Grid2>
            </Grid2>

            <Grid2 container justifyContent="flex-end" mt={3} mb={2}>
              <Button
                size="small"
                variant="text"
                type="button"
                onClick={() => setOpenDetailsModal(false)}
                className={classes.cancel}
              >
                cancel
              </Button>
              <Button size="small" color="primary" variant="contained" className={classes.editDetails} disabled={disableEdit} type="submit">
                <div className="caption" style={{ fontSize: 'h5', textTransform: 'none' }}>
                  Save Changes
                </div>
              </Button>
            </Grid2>
          </form>
        </DialogContent>
      </Dialog >

      {showConfirmationModal && (
        <ConfirmationDialog action="rename" confirm={handleConfirm} setShowAlert={setShowConfirmationModal} />
      )
      }

      {openPreFinalDetailsModal && selectedPreFinalFile && (
        <PreFinalFileContentDetails
          setOpenDetailsModal={setOpenPreFinalDetailsModal}
          id={selectedPreFinalFile.id}
          setRefresh={setRefresh}
          themeList={themeList}
        />
      )}
    </>
  );
};

export default FinalFileContentDetails;
